// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import styled from 'styled-components';
import Button from '../../../Button';
import RadioInput from '../../../RadioInput';
import AssessmentExplanationCorrectIcon from '../../../../assets/images/assessment-explanation-correct.svg';
import AssessmentExplanationWrongIcon from '../../../../assets/images/assessment-explanation-wrong.svg';
import LabelStyle from '../../../RadioInput/styles'

export const S = {
  Container: styled.div`
    display: flex;
    justify-content: center;
    align-content: space-between;
    flex-direction: column;
    flex-grow: 1;
    /* scroll-behavior: smooth; */
  `,
  Content: styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    overflow-y: auto;
    padding: 40px 119px;
  `,
  Footer: styled.div`
    width: 100%;
    height: 105px;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: space-between;
    padding-left: 200px;
    padding-right: 100px;
    border-top: 1px solid #EBEBEB;
  `,
  Button: styled(Button)`
    width: 142px;
  `,
  Guide: styled.div`
    font: 400 16px Noto Sans TC;
    color: #313131;
  `,
  Question: styled.div`
    font: 400 16px Noto Sans TC;
    color: #313131;
    margin: 40px 81px 50px 81px;
  `,
  CorrectLabel: styled.div`
    font-size: 16px;
    color: #00C6AD;
  `,
  DefaultLabel: styled.div`
    font-size: 16px;
    color: #434343;
  `,
  WrongLabel: styled.div`
    font-size: 16px;
    color: #434343;
    opacity: 0.5;
  `,
  InputWrapper: styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin: 0 95px;
    * {
      margin-bottom: 20px;
      margin-left: 9px;
    }
  `,
  RadioInput: styled(RadioInput)<{ isAnswered: boolean, isAnswer: boolean }>`
    ${LabelStyle.Label} {
      ${props => props.isAnswered ? props.isAnswer ? { color: '#00C6AD' } : { opacity: 0.5 } : undefined }
    }
  `,
  ExplanationContainer: styled.div<{ isCorrect: boolean }>`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    min-height: 100px;
    padding: 22px;
    background: ${props => props.isCorrect ? 'rgba(0, 198, 173, 0.1)' : 'rgba(255, 61, 61, 0.1)'};
    border-radius: 2px;
  `,
  ExplanationTitle: styled.div<{ isCorrect: boolean }>`
    font: 500 16px Noto Sans TC;
    line-height: 200%;
    color: #313131;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    position: relative;

    &::before {
      content: url(${props => props.isCorrect ? AssessmentExplanationCorrectIcon : AssessmentExplanationWrongIcon});
      margin-right: 20px;
      margin-top: 6px;
    }
  `,
  ExplanationText: styled.div`
    font: 400 16px Noto Sans TC;
    line-height: 200%;
    color: #313131;
    margin-left: 40px;
    word-break: break-all;
  `
};
